import { Part } from "./Part";

export const INITIAL_VALUES: Part = {
	partId: 0,
	partName: "",
	description: "",
	sku: "",
	unit: "",
	vendorId: 0,
	// Optional: with no date there is no PartRefurbishment row, so the part stays Available
	actualArrival: null,
	isActive: true,
	componentTypeIds: [],
};
